import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
 CardBody,
  CardHeader,
  Col,
  Collapse,
  Row,
} from "reactstrap";
import Record from "./table";
import Loader from "react-loaders";
import { useDocumentList } from "Api/Melder/Document";

const List = () => {
  const [accordion, setAccordion] = useState([]);

  const {
    data: response,
    isLoading,
    error,
  } = useDocumentList();

  const data = response?.documents || [];

  useEffect(() => {
    if (data.length > 0) {
      setAccordion(Array(data.length).fill(false));
    }
  }, [data]);

  const toggleAccordion = (index) => {
    setAccordion((prev) =>
      prev.map((item, i) => (i === index ? !item : false))
    );
  };

  return (
    <>
      <p className="doc-text">
        Onderstaand vindt u vervangers die de afgelopen 3 maanden op uw school
        vervangen hebben. Klik op de naam om beschikbare documenten te tonen.
      </p>

      <Row>
        <Col md="12">
          <div id="accordion" className="accordion-wrapper mb-3">
            {isLoading ? (
              <Loader
                type="ball-grid-pulse"
                className="mt-3 d-flex mx-auto justify-content-center"
              />
            ) : error ? (
              <div className="text-center">Er is iets misgegaan.</div>
            ) : data.length > 0 ? (
              data.map((substitute, index) => (
                <Card key={substitute?.admin_name + index}>
                  <CardHeader
                    id={`heading${index}`}
                    className="substitutor-card-header"
                  >
                    <Button
                      block
                      color="link"
                      className="text-start m-0 p-0"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={accordion[index]}
                      aria-controls={`collapse${index}`}
                    >
                      <h5 className="menu-header-title text-capitalize document-list-header">
                        {substitute?.admin_name} - {substitute?.vcity}
                      </h5>
                    </Button>
                  </CardHeader>

                  <Collapse
                    isOpen={accordion[index]}
                    data-parent="#accordion"
                    id={`collapse${index}`}
                    aria-labelledby={`heading${index}`}
                  >
                    <CardBody>
                      <Record data={substitute?.docs || []} />
                    </CardBody>
                  </Collapse>
                </Card>
              ))
            ) : (
              <div className="text-center">Geen document beschikbaar</div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default List;

